import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7e16a92c&scoped=true"
import script from "./newQuestion.js?vue&type=script&lang=js&external"
export * from "./newQuestion.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=7e16a92c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e16a92c",
  null
  
)

export default component.exports